export const sections = [
  {
    title: 'Verified Authenticity',
    description:
      'Every artwork is expert-authenticated as an original tied to the artist, preserving its integrity and value. Each Digital Original exists as a unique exemplar, ensuring its singularity.',
    icon: 'authenticity',
  },
  {
    title: 'Exclusive Rights to Own Digital',
    description:
      'Each purchase grants exclusive, verified digital ownership on the blockchain, offering a unique, transferable asset that cannot be duplicated.',
    icon: 'dr',
  },
  {
    title: 'Ultra-HD Image Quality',
    description:
      'Experience the artwork in ultra-high-definition resolution, capturing every texture and brushstroke, providing a viewing experience close to the original piece.',
    icon: 'do',
  },
  {
    title: 'Century-Long Preservation on Blockchain',
    description:
      'All artwork data, including metadata, is securely stored on the blockchain, guaranteeing preservation, accessibility, and protection against tampering for future generations.',
    icon: 'preservation',
  },
] as const;
